import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import Image from "next/image";

export function PortfolioExchangeImage(props: { src: string; alt: string }) {
  return (
    <span
      key={props.src}
      className="grid size-5 min-h-5 min-w-5 place-content-center rounded-full border bg-card"
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Image
              src={props.src}
              alt={props.alt ?? "exchange"}
              className="size-4 overflow-hidden rounded-full"
              width={18}
              height={18}
              sizes="18px"
            />
          </TooltipTrigger>
          <TooltipContent className="capitalize">{props.alt}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </span>
  );
}
